export const environment = {
    production: false,
    ENCRYPT_LOCAL_STORAGE: false,
    LANGUAGES_FILE_PATH: 'assets/i18n/',
    LOCAL_STORAGE_SECRET: 'D96Q2M84E3400063E8366912AQ45488H',
    ETH_HOLYSKY_TRANSACTION_URL:'https://holesky.etherscan.io/tx/',
    API_BASE_URL:'https://staginglockupbackend.alphaomegacoin.com/api/v1/user/',
    WEB3_APP_URL:'https://stagingweb3.alphaomegacoin.com/',
    DAPP_URL:'https://stagingtokendistribution.alphaomegacoin.com/',    
    EN_MIRROR_BOOK:"https://www.alphaomegacoin.com/assets/frontend/docs/en/pdf_v1_aoc_mirror_book.pdf",
    FR_MIRROR_BOOK:"https://www.alphaomegacoin.com/assets/frontend/docs/fr/pdf_v1_aoc_mirror_book.pdf",
    EN_AUDIT_LINK:"https://drive.google.com/file/d/17vYMxEIuW4at6aTdXshbJFUHm3KMluzT/view?usp=sharing",
    FR_AUDIT_LINK:"https://drive.google.com/file/d/17qkfmPFi6ha1OOEh2RO3bB4sbhFEv2d_/view?usp=sharing",
    EN_WHATSAPP_LINK:"https://whatsapp.com/channel/0029Vb5qc5JGk1FpNl8qy30g",
    FR_WHATSAPP_LINK:"https://whatsapp.com/channel/0029VaGARw98PgsOIqrx9Q3J",
    PLAYSTORE_LINK:"https://rtyxi.test-app.link/ifoMSAJzDSb?ref=",
    BSC_SCAN_URL:"https://testnet.bscscan.com/tx/"


};
